import Tooltip from "@/components/Tooltip";
import IconEdit1 from "@/icons/IconEdit1";
import IconTrash from "@/icons/IconTrash";
import React from "react";

interface Props {
  onEdit(): void;
  onDelete(): void;
}

export default function PronunciationActionBar(props: Props) {
  return (
    <div className="flex flex-row gap-4 items-center w-24 text-slate-400">
      <Tooltip text="Edit" direction="top" minWidth="50px">
        <div
          className="hover:cursor-pointer hover:text-cornflower-blue-500"
          onClick={props.onEdit}
        >
          <IconEdit1 />
        </div>
      </Tooltip>
      <Tooltip text="Delete" direction="top" minWidth="60px">
        <div
          className="hover:cursor-pointer hover:text-cornflower-blue-500"
          onClick={props.onDelete}
        >
          <IconTrash />
        </div>
      </Tooltip>
    </div>
  );
}
